<script>
import mixins from 'viralstyle-ui/src/vueMixins';
import ProductGroup from 'sales-flow-ui/components/ProductGroup';
import VsAlert from 'viralstyle-ui/src/VsAlert';
import { mapState } from 'vuex';

import store from '@/store';
import Pagination from './HomePagination';

export default {
  components: {
    ProductGroup,
    Pagination,
    VsAlert,
  },
  mixins: [mixins],
  props: {
    page: {
      type: String,
      default: '1',
    },
  },
  computed: {
    ...mapState(['processing', 'searchApplied', 'currencyInfo', 'domainConfig']),
    ...mapState({
      campaigns: state => state.home.campaigns.collection,
    }),
    bannerSrc() {
      return ['md', 'sm'].includes(this.$mq) ? this.domainConfig.assets.banner_mobile || this.domainConfig.assets.banner : this.domainConfig.assets.banner;
    },
  },
  async beforeRouteUpdate(to, from, next) {
    if (to.params.nav) {
      await this.$store.dispatch('getCampaigns', { page: to.params.page });
    }

    next();
  },
  async created() {
    if (this.$route.query.search) {
      this.updateState(this.$store.state, 'search', this.$route.query.search);
      this.updateState(this.$store.state, 'searchApplied', true);
    }

    let redirect = this.$route.name === 'home' && this.searchApplied;

    await this.$store.dispatch('getCampaigns', { page: this.page, redirect });
  },
};
</script>

<template lang='pug'>
div
  img.opacity-100.mx-auto(
    v-if='bannerSrc',
    :alt='`${domainConfig.company_name} banner`',
    :src='bannerSrc',
  )
  .container.mx-auto.my-2.md_my-4(v-if='campaigns.length')
    product-group(
      is-whitelabel,
      center,
      wrap,
      full-width-images,
      :campaigns='campaigns',
      :currency-info='currencyInfo',
    )

    pagination(:page='page')

  .container.mx-auto(v-else-if='!processing')
    vs-alert.mt-4(message='No products found...')
</template>

<style>
</style>